import { neutral } from "@flat-ui";
import { SxProps, Theme } from "@mui/material";
import { CommonStyles } from "@styles/common-styles";

/** Gap between sections in the in-house analytics layout (MUI spacing units) */
export const IN_HOUSE_ANALYTICS_SECTION_GAP = 2;

/** Shared styles for placeholder section containers */
export const sectionPlaceholderStyles: SxProps<Theme> = {
  border: CommonStyles.Borders.gray200Divider,
  borderRadius: "0.5rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: neutral[500],
};
